import React from 'react';
import SolutionInstallmentExaminationCompletedWrapper from 'components/SolutionInstallmentExaminationCompletedWrapper/SolutionInstallmentExaminationCompletedWrapper';

export default function SolutionInstallmentExaminationCompletedContainer() {
    return (
        <SolutionInstallmentExaminationCompletedWrapper />
    )
}
